import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton } from "@mui/material"
import { formatarValorMonetario } from "../../helpers/masks"
import { TModalEditDataAPI, TListaParcelasAPI } from "./SelecaoCondicaoParcelamentoAPI"
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';

export default function ListagemParcelasAPI({
    listaParcelas,
    valorTotalComJuros,
    prctDiferencaTotal,
    blockEdit = false,
    loading = false,
    handleOpenModalEdit,    
    permiteEdicaoVencimento = false
}: ListagemParcelasAPIProps) {
    
    if (loading) {
        return (
            <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2, mt: 2 }}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell><b>Parcela</b></TableCell>
                            <TableCell align="right"><b>Vencimento</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.from({ length: 3 }, (_, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Skeleton variant="text" width="80%" />
                                </TableCell>
                                <TableCell align="right">
                                    <Skeleton variant="text" width="60%" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    return (
        <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2, mt: 2 }}>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell><b>Parcela</b></TableCell>
                        <TableCell align="right"><b>Vencimento</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        listaParcelas.map((item: TListaParcelasAPI, index: number) => {
                            return (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {`${item.numero}ª ${formatarValorMonetario(item.valor)}`}
                                        {item.dias_ate_vencimento && (
                                            <span style={{ fontSize: '0.75rem', color: '#666', marginLeft: '8px' }}>
                                                ({item.dias_ate_vencimento} dias)
                                            </span>
                                        )}
                                    </TableCell>
                                    <TableCell sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: 0.5
                                    }}
                                    >
                                        {item.vencimento}
                                        <IconButton
                                            size="small"
                                            aria-label="edit"
                                            sx={{ margin: 0 }}
                                            onClick={() => handleOpenModalEdit({
                                                index, 
                                                date: item.vencimento
                                            })}
                                            disabled={blockEdit || !permiteEdicaoVencimento}
                                        >
                                            {permiteEdicaoVencimento ? (
                                                <EditIcon
                                                    sx={{ fontSize: 16 }}
                                                />
                                            ) : (
                                                <LockIcon
                                                    sx={{ fontSize: 16 }}
                                                />
                                            )}
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <b>Valor total</b>
                        </TableCell>
                        <TableCell align="right">
                            <b>{formatarValorMonetario(valorTotalComJuros)} <i>({prctDiferencaTotal})</i></b>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

interface ListagemParcelasAPIProps {
    listaParcelas: Array<TListaParcelasAPI>,
    valorTotalComJuros: number,
    prctDiferencaTotal: string,
    handleOpenModalEdit: (arg: TModalEditDataAPI) => void
    blockEdit?: boolean
    loading?: boolean
    permiteEdicaoVencimento?: boolean
}
